/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SendMessageCommandDto interface.
 */
export function instanceOfSendMessageCommandDto(value) {
    if (!('chatId' in value) || value['chatId'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    return true;
}
export function SendMessageCommandDtoFromJSON(json) {
    return SendMessageCommandDtoFromJSONTyped(json, false);
}
export function SendMessageCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'chatId': json['chatId'],
        'body': json['body'],
    };
}
export function SendMessageCommandDtoToJSON(json) {
    return SendMessageCommandDtoToJSONTyped(json, false);
}
export function SendMessageCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'chatId': value['chatId'],
        'body': value['body'],
    };
}
